import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4 text-white" data-id="element-111">
      <div className="max-w-3xl mx-auto border-2 border-gray-800 rounded-2xl p-8 md:p-12 text-center bg-gray-900/50" data-id="element-112">
        <ShieldCheck size={64} className="text-yellow-400 mx-auto mb-6" data-id="element-113" />
        <h2 className="text-3xl md:text-4xl font-black text-white mb-6" data-id="element-114">
          Garantía Sin Riesgo — 30 Días
        </h2>
        <p className="text-lg text-gray-300 font-medium leading-relaxed" data-id="element-115">
          Probá el sistema durante 30 días completos. Si no te ayuda a resolver
          averías y organizar tu instalación eléctrica, solicitá la devolución
          completa. Sin preguntas. Sin formularios. Sin excusas. El riesgo es
          completamente nuestro.
        </p>
      </div>
    </section>;
}